var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Loading } from 'element-ui';
import { Component } from 'vue-property-decorator';
import { auth } from '../../helper/authDecorator';
import { nameDict } from '../../constant/authCode';
import PurchaseService from '../../api/PurchaseService';
import CommonService from '../../api/CommonService';
import HeaderItem from '../accountcheck/components/HeaderItem.vue';
import TableHeaderToolTip from './components/TableHeaderToolTip.vue';
var Detail = (function (_super) {
    __extends(Detail, _super);
    function Detail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.detail = { data: [] };
        _this.total = 0;
        _this.start = 0;
        _this.orderid = '';
        _this.data = [];
        _this.supplierGoodsTypeList = [];
        _this.goodsFormData = {
            goods_type_id: undefined,
            keyword: '',
        };
        return _this;
    }
    Detail.prototype.created = function () {
        this.purchaseService = PurchaseService.getInstance();
        this.commonService = CommonService.getInstance();
        this.getDetail();
        this.getGoodsTypeList();
        this.tableHeight = document.body.clientHeight - 327;
    };
    Detail.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    Detail.prototype.search = function () {
        this.getDetail();
    };
    Detail.prototype.getGoodsTypeList = function () {
        var _this = this;
        this.commonService.getSupplierGoodsTypeList().then(function (res) {
            if (res.data.success) {
                _this.supplierGoodsTypeList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Detail.prototype.pageChange = function (pager) {
        this.start = pager.start;
        this.getDetail();
    };
    Detail.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.rowId,
            start: this.start,
            goods_type_id: this.goodsFormData.goods_type_id,
            keyword: this.goodsFormData.keyword,
        };
        this.purchaseService
            .getDetail(params)
            .then(function (res) {
            loadingInstance.close();
            _this.data = res.data.data;
            _this.total = res.data.total || 0;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    Detail = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem,
                TableHeaderToolTip: TableHeaderToolTip,
            },
            methods: {
                renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: '税额=含税金额/(1+税率)*税率',
                            placement: 'bottom',
                        },
                    }, '税额');
                },
            },
        }),
        auth(nameDict["采购入库"], true)
    ], Detail);
    return Detail;
}(Vue));
export default Detail;
